import { Flex } from "@chakra-ui/react"
import WhyImage5 from "@public/images/hero/why-image-5.png"
import Image from "next/image"
import { useTranslations } from "next-intl"

export default function Highlight() {
  const t = useTranslations("why")

  return (
    <Flex
      justify={"space-evenly"}
      mt={100}
      flexWrap={"wrap"}
      align={"center"}
      display={{ base: "none", md: "flex" }}
    >
      <Flex
        justify={"center"}
        align={"center"}
        textAlign={"center"}
        color={"white"}
        backgroundColor={"#CEA673"}
        borderRadius={"full"}
        w={{ base: 24, lg: 32 }}
        h={{ base: 24, lg: 32 }}
      >
        {t("more_revenue")}
      </Flex>
      <Flex
        justify={"center"}
        align={"center"}
        textAlign={"center"}
        color={"white"}
        backgroundColor={"#41D58B"}
        borderRadius={"full"}
        w={{ base: 36, lg: 48 }}
        h={{ base: 36, lg: 48 }}
      >
        {t("customer_satisfaction")}
      </Flex>
      <Image
        src={WhyImage5}
        loader={({ src }) => src}
        width={200}
        height={410}
        alt={"Why eMenu"}
        placeholder={"blur"}
      />
      <Flex
        justify={"center"}
        align={"center"}
        textAlign={"center"}
        color={"white"}
        backgroundColor={"#9DBC47"}
        borderRadius={"full"}
        w={{ base: 36, lg: 48 }}
        h={{ base: 36, lg: 48 }}
      >
        {t("custom_designs")}
      </Flex>
      <Flex
        justify={"center"}
        align={"center"}
        textAlign={"center"}
        color={"white"}
        backgroundColor={"#85A89F"}
        borderRadius={"full"}
        w={{ base: 24, lg: 32 }}
        h={{ base: 24, lg: 32 }}
      >
        {t("easy_to_use")}
      </Flex>
    </Flex>
  )
}
